<template>
  <a class="card" @click="action" v-bind:class="couponColor()">
    <div class="image">
      <img :src="image" />
      <div class="expire">
        {{ this.expireAtStr }}
      </div>
      <div
        class="button_area"
        v-if="
          (this.prize_type === '1' ||
            this.prize_type === '2' ||
            this.prize_type === '3') &&
            isExpiredDate(this.expireAt) == '0'
        "
      >
        <img src="@/assets/img/coupon/freepass_use01.png" />
      </div>
      <div
        class="button_area"
        v-else-if="
          (this.prize_type === '1' ||
            this.prize_type === '2' ||
            this.prize_type === '3') &&
            isExpiredDate(this.expireAt) == '1'
        "
      >
        <img src="@/assets/img/coupon/freepass_use_expire01.png" />
      </div>
      <div
        class="button_area"
        v-else-if="
          this.prize_type === '4' && isExpiredDate(this.expireAt) == '0'
        "
      >
        <img src="@/assets/img/coupon/freepass_use02.png" />
      </div>
      <div
        class="button_area"
        v-else-if="
          this.prize_type === '4' && isExpiredDate(this.expireAt) == '1'
        "
      >
        <img src="@/assets/img/coupon/freepass_use_expire02.png" />
      </div>
    </div>
  </a>
</template>

<script>
export default {
  name: 'FreepassCard',
  props: {
    couponId: { type: String, required: true },
    expireAt: { type: String },
    category: { type: String },
    image: { type: String },
    title: { type: String, required: true },
    subtitle: { type: String },
    headingSmall: { type: String },
    headingLarge: { type: String },
    isHtml: { type: Boolean },
    type: { type: String },
    giftExpire: { type: String },
    isOff: { type: Boolean },
    prize_type: { type: String }
  },
  data: function() {
    return {
      currentCoupon: null,
      isAndroid: false
    }
  },
  mounted: function() {
    const ua = window.navigator.userAgent
    if (ua.indexOf('Android') >= 0) {
      this.isAndroid = true
    }
  },
  computed: {
    expireAtStr: function() {
      if (this.expireAt) {
        if (this.expireAt === '9999-12-31 23:59:59') {
          return '無期限'
        }

        const array = this.expireAt.split(' ')
        const date = array[0].split('-').join('/')
        const time = array[1].split(':')
        return `[有効期限] ${date} ${time[0]}:${time[1]}`
      } else {
        return `ー`
      }
    }
  },
  methods: {
    action() {
      this.$emit('click')
    },
    __createExpiredDate(str) {
      const array = str.split(' ')
      const date = array[0].split('-').join('/')
      const time = array[1].split(':')
      return `${date} ${time[0]}:${time[1]}`
    },
    couponColor: function() {
      return {
        diamond: this.prize_type === '4',
        platinium: this.prize_type === '3',
        gold: this.prize_type === '2',
        silver: this.prize_type === '1'
      }
    },
    isExpiredDate(str) {
      const array = str.split(' ')
      const dateStr = array[0].split('-').join('/')
      const date1 = new Date(Date.now())
      const date2 = new Date(dateStr)
      if ((date2 - date1) / 86400000 < 7) {
        return '1'
      } else {
        return '0'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  margin-bottom: 10px;
  display: inline-block;
  width: 100%;

  .image {
    width: 100%;
    position: relative;
    color: white;
    img {
      width: 100%;
    }
    div.expire {
      left: 0;
      right: 0;
      position: absolute;
      top: 55%;
      text-align: center;
    }
    div.button_area {
      position: absolute;
      text-align: center;
      top: 77%;
      margin: auto;
      width: 80%;
      left: 0;
      right: 0;

      a {
        background-color: #66160E;
        display: inline-block;
        text-align: center;
        font-size: 14px;
        border-radius: 5px;
        padding: 6px 20px;
      }
    }
    .div.button_area::before {
      position: absolute;
      right: -30px;
      transform: scale(0.3);
      content: url('~@/assets/img/coupon/expire_icon.png');
    }
  }

  &.diamond {
    div.expire {
      color: #deaa07;
    }
    div.button_area a {
      background-color: #deaa07;
    }
  }
  // &.platinium {
  //   background-color: #6ea1c7;
  // }
  // &.gold {
  //   background-color: #c0a417;
  // }
  // &.silver {
  //   background-color: #9f9f9f;
  // }
}
</style>
